const ORDER_STATUS_LABELS = {
  open: "Active",
  won: "Won",
  lost: "Lost",
  closed_by_inverse: "Cashed Out",
  used_as_inverse_close: "Used to Close Another Holding",
};

export function formatOrderStatus(status) {
  if (ORDER_STATUS_LABELS[status]) return ORDER_STATUS_LABELS[status];
  return String(status || "Unknown")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (character) => character.toUpperCase());
}

export function getDisplayedStake(order, showHistory = false) {
  const stake = Number(
    showHistory
      ? order.order_amount
      : (order.remaining_amount ?? order.order_amount ?? 0),
  );
  return Number.isFinite(stake) && stake > 0 ? stake : 0;
}
